import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { getMilestoneLatestUpdatedAt, getMilestonesFetched } from '../State/selectors/milestone.selector';
import { MilestoneActionTypes } from '../State/actions/milestone.actions';

@Injectable({
    providedIn: 'root',
})
export class MilestoneResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getMilestonesFetched, getMilestoneLatestUpdatedAt, MilestoneActionTypes.Load, store);
    }
}
